<template>
    <div>
        <div class="ix-comments-loader" v-if="loading">
            <i class="far fa-circle-notch fa-spin"></i> Chargement des tâches
        </div>

        <div class="ix-sidebar ix-sidebar-large" id="task-sidebar">
            <div class="ix-sidebar-header">
                <h2 class="ix-sidebar-title">Détails de la tâche {{ selectedTask ? '#' + selectedTask.number : '' }}</h2>
                <button class="ix-sidebar-btn-close trigger-close-sidebar">
                    <i class="fal fa-times"></i>
                </button>
            </div>

            <div class="ix-sidebar-content">
                <div class="ix-comments-loader" v-if="loadingShow">
                    <i class="far fa-circle-notch fa-spin"></i> Récupération des informations de la tâche
                </div>

                <div v-if="!loadingShow && selectedTask">
                    <button type="button" @click="changeState(selectedTask)" class="ix-task-state"
                        v-bind:class="{ 'green': selectedTask.state == 3, 'blue': selectedTask.state == 2 }">
                        <span v-if="selectedTask.state == 1"><i class="far fa-snooze"></i></span>
                        <span v-if="selectedTask.state == 2"><i class="far fa-play"></i></span>
                        <span v-if="selectedTask.state == 3"><i class="far fa-check"></i></span>
                    </button>
                    <h2 class="ix-task-card-title"><a :href="detailsUrl">{{ selectedTask.designation }}</a></h2>

                    <p v-html="nl2br(selectedTask.description)" v-if="selectedTask.description" class="mt-3"></p>
                    <span v-if="!selectedTask.description" class="d-block ix-text-secondary ix-text-small mt-3">Pas de
                        description renseignée</span>

                    <div class="ix-table-box mb-4">
                        <table class="ix-table ix-table-sm">
                            <tbody>
                                <tr>
                                    <td>
                                        <span class="ix-text-secondary">Suivi par</span>
                                    </td>
                                    <td class="text-right">
                                        <span class="ix-avatar xsm">
                                            <img :src="selectedTask.user.avatar_path" v-if="selectedTask.user.avatar_path">
                                            <span v-if="!selectedTask.user.avatar_path">{{ selectedTask.user.initial
                                            }}</span>
                                        </span>

                                        {{ selectedTask.user.fullname }}
                                    </td>
                                </tr>
                                <tr v-if="selectedTask.opportunity">
                                    <td>
                                        <span class="ix-text-secondary">Opportunité</span>
                                    </td>
                                    <td class="text-right">{{ selectedTask.opportunity.designation }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="ix-text-secondary">Type</span>
                                    </td>
                                    <td class="text-right">{{ selectedTask.event ? selectedTask.event.name : 'Todo' }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="ix-text-secondary">Date de création</span>
                                    </td>
                                    <td class="text-right">{{ selectedTask.created_at | formatDate('DD MMM YYYY') }}</td>
                                </tr>
                                <tr v-if="selectedTask.due_at">
                                    <td>
                                        <span class="ix-text-secondary">Date d'échéance</span>
                                    </td>
                                    <td class="text-right">
                                        <span v-bind:class="{ 'ix-text-red ix-text-bold': selectedTask.is_due }">{{
                                            selectedTask.due_at | formatDate('DD MMM YYYY') }}</span>
                                    </td>
                                </tr>
                                <tr v-if="selectedTask.tags.length > 0">
                                    <td>
                                        <span class="ix-text-secondary">Tags</span>
                                    </td>
                                    <td class="text-right">
                                        <span class="ix-tag mr-1" v-bind:class="{ 'light': tag.light_font }"
                                            v-bind:style="{ 'background-color': tag.color }"
                                            v-for="(tag, tagIndex) in selectedTask.tags" :key="tagIndex">
                                            {{ tag.name }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="mb-3">
                        <h2 class="ix-page-title-secondary">Sous-tâches</h2>
                        <subtasks-manager :task-id="selectedTask.id" :url="subtasksRoute"
                            :state-subtask-url="stateSubtasksRoute" :workable="selectedTask.is_workable"
                            :editable="selectedTask.is_editable" :admin="admin">
                        </subtasks-manager>
                    </div>

                    <div v-if="selectedTask.users.length > 0" class="mb-3">
                        <h3 class="ix-page-title-secondary">Affectation</h3>
                        <div class="ix-table-box">
                            <table class="ix-table ix-table-sm">
                                <tbody>
                                    <tr v-for="(user, userIndex) in selectedTask.users" :key="userIndex">
                                        <td>
                                            <span class="ix-avatar xsm">
                                                <img :src="user.avatar_path" v-if="user.avatar_path">
                                                <span v-if="!user.avatar_path">{{ user.initial }}</span>
                                            </span>

                                            {{ user.fullname }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="selectedTask.companies.length > 0" class="mb-3">
                        <h3 class="ix-page-title-secondary">Sociétés associées</h3>
                        <div class="ix-table-box">
                            <table class="ix-table ix-table-sm">
                                <tbody>
                                    <tr v-for="(company, companyIndex) in selectedTask.companies" :key="companyIndex">
                                        <td>
                                            <span class="ix-avatar xsm">
                                                <img :src="company.logo_path" v-if="company.logo_path">
                                                <span v-if="!company.logo_path"><i class="far fa-building"></i></span>
                                            </span>

                                            <a class="ix-link" :href="companiesRoute + '/' + company.id">{{ company.name
                                            }}</a>
                                            <div class="company-info" v-for="(contact, contactIndex) in company.contacts"
                                                :key="contactIndex" v-if="contact.phone">
                                                <small><i class="fas fa-phone-alt"></i> {{ contact.phone }}</small>
                                                <small>{{ contact.fullname }}</small>
                                            </div>
                                            <div class="company-info" v-for="(address, addressIndex) in company.addresses"
                                                :key="addressIndex" v-if="address.is_default">
                                                <small><i class="fas fa-home"></i> {{ address.address_1 }} </small>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="ix-checking-sidebar-actions mt-4">
                        <a :href="detailsUrl + '/edit'" v-if="selectedTask.is_editable" class="ix-btn ix-btn-block mb-2"><i
                                class="far fa-pen"></i> Modifier</a>

                        <button type="button" class="ix-btn ix-btn-block transparent" v-bind:disabled="loadingDelete"
                            v-if="selectedTask.is_deletable" @click="deleteTask(selectedTask)">
                            <span v-if="!loadingDelete"><i class="far fa-trash"></i> Supprimer</span>
                            <span v-if="loadingDelete"><i class="far fa-circle-notch fa-spin"></i> Suppression en
                                cours</span>
                        </button>
                    </div>

                    <h3 class="ix-page-title-secondary mt-4">Commentaires</h3>
                    <comments :commentable-id="selectedTask.id" :url="commentsRoute" commentable-type="App\Models\Task"
                        :admin="admin" order="normal"></comments>

                    <h3 class="ix-page-title-secondary mt-4">Documents</h3>
                    <documents-manager :documentable-id="selectedTask.id" :url="documentsRoute" :roles-url="rolesRoute"
                        documentable-type="App\Models\Task" :admin="admin" display="min"
                        readonly="true"></documents-manager>

                </div>
            </div>
        </div>

        <div v-show="!loading">
            <div class="ix-table-box" v-if="tasks.length > 0">
                <table class="ix-table">
                    <thead>
                        <tr>
                            <th>État</th>
                            <th>Tâche</th>
                            <th>Affectation</th>
                            <th>Sociétés associées</th>
                            <th>Type</th>
                            <th>Tags</th>
                            <th>Date de création</th>
                            <th>Date d'échéance</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(task, index) in tasks" :key="index">
                            <td>
                                <button type="button" @click="changeState(task)" class="ix-task-state"
                                    v-bind:class="{ 'green': task.state == 3, 'blue': task.state == 2 }">
                                    <span v-if="task.state == 1"><i class="far fa-snooze"></i></span>
                                    <span v-if="task.state == 2"><i class="far fa-play"></i></span>
                                    <span v-if="task.state == 3"><i class="far fa-check"></i></span>
                                </button>
                            </td>
                            <td>
                                <span class="ix-text-secondary">#{{ task.number }}</span>
                                <button class="ix-btn link trigger-sidebar" type="button" @click="openTask(task.id)"
                                    style="line-height: 14px;">{{ task.designation }}</button>
                            </td>
                            <td>
                                <div class="ix-avatars-list" v-if="task.users.length">
                                    <span class="ix-avatars-list-item" v-for="(user, userIndex) in task.users"
                                        :key="userIndex">
                                        <span class="ix-avatar sm" v-b-tooltip :title="user.fullname">
                                            <img :src="user.avatar_path" v-if="user.avatar_path">
                                            <span v-if="!user.avatar_path">{{ user.initial }}</span>
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="ix-avatars-list" v-if="task.companies.length">
                                    <span class="ix-avatars-list-item" v-for="(company, companyIndex) in task.companies"
                                        :key="companyIndex">
                                        <span class="ix-avatar sm" v-b-tooltip :title="company.name">
                                            <img :src="company.logo_path" v-if="company.logo_path">
                                            <span v-if="!company.logo_path"><i class="far fa-building"></i></span>
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <span v-if="task.event">{{ task.event.name }}</span>
                                <span v-if="!task.event">Todo</span>
                            </td>
                            <td>
                                <span class="ix-tag mr-1" v-bind:class="{ 'light': tag.light_font }"
                                    v-bind:style="{ 'background-color': tag.color }" v-for="(tag, tagIndex) in task.tags"
                                    :key="tagIndex">
                                    {{ tag.name }}
                                </span>
                            </td>
                            <td>
                                <span class="ix-text-secondary">{{ task.created_at | formatDate('DD MMM YYYY') }}</span>
                            </td>
                            <td>
                                <span v-if="task.due_at" v-bind:class="{ 'ix-text-red ix-text-bold': task.is_due }">{{
                                    task.due_at | formatDate('DD MMM YYYY') }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
import Swal from "sweetalert2";
import Comments from "../Comments"
import DocumentsManager from "../DocumentsManager"
import SubtasksManager from "./SubtasksManager"

export default {
    name: "TasksTable",
    components: {
        Comments,
        DocumentsManager,
        SubtasksManager
    },
    props: {
        admin: Number,
        url: String,
        detailsRoute: String,
        commentsRoute: String,
        documentsRoute: String,
        subtasksRoute: String,
        stateSubtasksRoute: String,
        rolesRoute: String,
        taskIdToOpen: String,
        companiesRoute: String
    },
    data() {
        return {
            loading: true,
            loadingShow: false,
            loadingDelete: false,
            is_admin: this.admin || false,

            tasks: [],

            selectedTask: null,
            newTask: ''
        }
    },
    computed: {
        detailsUrl: function () {
            return this.selectedTask ? this.detailsRoute.replace('##', this.selectedTask.id) : ''
        },
    },
    methods: {
        openTask: function (taskId) {
            this.selectedTask = null
            this.loadingShow = true

            $('#list-filters').removeClass('open');
            $('#task-sidebar').addClass('open');

            fetch(this.url + '/' + taskId, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loadingShow = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.selectedTask = data
                    })
                } else {
                    this.closeTaskSidebar()
                }
            }).catch(error => {
                this.loadingShow = false;
                this.closeTaskSidebar()
                console.log(error)
            });
        },
        closeTaskSidebar: function () {
            this.selectedTask = null
            this.loadingShow = false
            $('#task-sidebar').removeClass('open');
        },
        async getData() {
            this.loading = true;
            fetch(this.url + window.location.search, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loading = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.tasks = data.data
                    })
                }
            }).catch(error => {
                this.loading = false;
                console.log(error)
            });
        },
        async changeState(task) {
            if (task.is_workable) {
                var newState = 1
                var backupState = task.state

                if (task.state == 1) {
                    newState = 2
                } else if (task.state == 2) {
                    newState = 3
                }

                task.state = newState

                fetch(this.url + '/' + task.id + '/state', {
                    ...{
                        method: 'PUT'
                    },
                    ...this.getHttpJsonRequestHeaders(),
                    ...{
                        body: JSON.stringify({
                            state: newState,
                        })
                    }
                }).then((response) => {
                    if (response.status == 200) {
                        var taskIndexInTable = this.tasks.findIndex(t => {
                            return t.id == task.id
                        })

                        if (taskIndexInTable >= 0) {
                            this.tasks[taskIndexInTable].state = newState
                        }
                    } else {
                        task.state = backupState
                    }
                }).catch(error => {
                    task.state = backupState
                    console.log(error);
                })
            }
        },
        async deleteTask(task) {
            this.$swal({
                title: "Êtes vous sûr ?",
                text: "La tâche sera définitivement supprimée",
                icon: "warning",
                dangerMode: true,
                buttons: ["Annuler", "Supprimer"]
            }).then((willDo) => {
                if (willDo) {
                    this.loadingDelete = true

                    fetch(this.url + "/" + task.id, {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then(async (response) => {
                        if (response.status == 200) {
                            window.location.reload()
                        } else {
                            this.loadingDelete = false
                        }
                    }).catch(error => {
                        this.loadingDelete = false
                        console.log(error);
                    })

                }
            });
        },
    },

    async mounted() {
        await this.getData();

        if (this.taskIdToOpen != null && this.taskIdToOpen != '') {
            history.pushState("", document.title, window.location.pathname);
            this.openTask(this.taskIdToOpen)
        }
    }
}
</script>
